module.exports = __webpack_public_path__ + "static/media/ic-arrow-left.ee0fd3a1.svg";